import { Link } from '@inertiajs/react'
import { linkClass } from './ui'

export default function AdminNav({ current }: { current: 'review' | 'sources' }) {
  return <nav aria-label="Catalog administration" className="mb-8 flex flex-wrap gap-x-6 gap-y-2 border-b border-line pb-4 text-sm">
    <Link href="/admin/fix_list" aria-current={current === 'review' ? 'page' : undefined} className={`${linkClass} aria-[current=page]:font-semibold aria-[current=page]:decoration-brand`}>Review queue</Link>
    <Link href="/admin/sources" aria-current={current === 'sources' ? 'page' : undefined} className={`${linkClass} aria-[current=page]:font-semibold aria-[current=page]:decoration-brand`}>Sources</Link>
    <Link href="/shafts" className={linkClass}>Public catalog ↗</Link>
  </nav>
}
